<app-header 
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>
<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'terms.title' | translate}}
  </div>
  <div class="terms">
    <div [innerHTML]="'terms.intro' | translate"></div>
    <div [innerHTML]="'terms.account' | translate"></div>
    <div [innerHTML]="'terms.usage' | translate"></div>
    <div [innerHTML]="'terms.data' | translate"></div>
    <div [innerHTML]="'terms.liability' | translate"></div>
    <div [innerHTML]="'terms.changes' | translate"></div>
    <div [innerHTML]="'terms.termination' | translate"></div>
  </div>
</div>